import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import FinalCTA from "@/components/FinalCTA";
import SafeImage from "@/components/SafeImage";
import { IMAGES, BENEFITS } from "@/data/content";
import { CheckCircle2 } from "lucide-react";

const About = () => {
  return (
    <>
      <SEO />
      <PageHero
        crumbs={[{ label: "Početna", to: "/" }, { label: "O nama" }]}
        title="O nama"
        lead="RB TIM — standardni kontejneri za praktičnu upotrebu, brzu izradu i različite namene."
      />

      <section className="section" data-testid="about-intro">
        <div className="container-rb feature-row">
          <div>
            <span className="eyebrow">RB TIM</span>
            <h2 style={{ marginTop: 8 }}>Praktična kontejnerska rešenja</h2>
            <p style={{ color: "#374151" }}>
              RB TIM se bavi izradom standardnih kontejnera za različite namene
              — od kancelarijskih i građevinskih kontejnera, do sanitarnih,
              stambenih, pomoćnih objekata i portirnica.
            </p>
            <p style={{ color: "#374151" }}>
              Naš fokus je na praktičnim rešenjima, brzoj izradi i kontejnerima
              koji odgovaraju realnim potrebama kupaca. Umesto komplikovanih
              sistema i skupih rešenja, nudimo funkcionalne modele koji se
              mogu koristiti za posao, teren, stanovanje ili pomoćni prostor.
            </p>
          </div>
          <div className="feature-row__media">
            <SafeImage src={IMAGES.industrial} alt="RB TIM proizvodnja kontejnera" label="RB TIM" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="section section--gray" data-testid="about-benefits">
        <div className="container-rb">
          <SectionHeader eyebrow="Vrednosti" title="Zbog čega nas biraju" lead="Fokusirani smo na funkcionalna rešenja, jasan dogovor i praktične kontejnere koji se brzo isporučuju." />
          <div className="grid-3">
            {BENEFITS.map((b, i) => (
              <div key={b.title} className="benefit-card" data-testid={`about-benefit-${i}`}>
                <div className="benefit-card__icon"><CheckCircle2 size={22} /></div>
                <h3>{b.title}</h3>
                <p>{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </>
  );
};

export default About;
